import { useMemo, useEffect } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { ClinicWithConditionsAndPromo } from '../../../../Clinics/types';

interface UseDisplayOrderOfConditionsProps {
  form: UseFormReturn<ClinicWithConditionsAndPromo>;
  index: number;
}

export const useDisplayOrderOfConditions = ({ form, index }: UseDisplayOrderOfConditionsProps) => {
  const condition = form.watch(`clinic_conditions.${index}`);
  const allConditions = useMemo(() => form.watch('clinic_conditions') || [], [form]);
  const maxOrderNumber = useMemo(() => allConditions.length, [allConditions]);

  const availableOrderNumbers = useMemo<number[]>(() => {
    const isOrderTaken = (orderValue: number) => {
      return allConditions.some((cond, idx) =>
        idx !== index && cond.order?.default === orderValue
      );
    };

    const numbers: number[] = [];
    const currentValue = condition?.order?.default;

    if (currentValue && currentValue <= maxOrderNumber) {
      numbers.push(currentValue);
    }

    for (let i = 1; i <= maxOrderNumber; i++) {
      if (!isOrderTaken(i) && i !== currentValue) {
        numbers.push(i);
      }
    }

    return numbers.sort((a, b) => a - b);
  }, [maxOrderNumber, condition?.order?.default, allConditions, index]);

  useEffect(() => {
    const currentOrder = condition?.order?.default;

    if (!currentOrder && availableOrderNumbers.length > 0) {
      const orderPath = `clinic_conditions.${index}.order`;
      
      if (!condition?.order) {
        form.setValue(orderPath as any, { default: availableOrderNumbers[0] });
      } else {
        form.setValue(`${orderPath}.default` as any, availableOrderNumbers[0]);
      }
    }
  }, [condition, availableOrderNumbers, form, index]);

  return {
    maxOrderNumber,
  };
};
